import React, { useEffect, useState } from 'react';
import { Layout, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchTypeProducts } from '../../services';
import HeaderNav from '../headerNav';
import HeaderActions from '../headerActions';
import ModalWindow from '../modalWindow';
import useMobileKeyboardOffset from './useMobileKeyboardOffset';
import './appHeader.scss';

const { Header } = Layout;

const AppHeader = () => {
  useMobileKeyboardOffset();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isAuthenticated } = useAppSelector((s) => s.user);
  const cartItemsCount = useAppSelector((s) => s.shoppingCart.addedTooCartProductCountAndIds.count);
  const likedProductCount = useAppSelector((s) => s.likedProduct.likedProductCountAndIds.count);
  const cartItemsLength = useAppSelector((s) => s.shoppingCart.cartItems.length);
  const likedProductsLength = useAppSelector((s) => s.likedProduct.likedProducts.length);
  const types = useAppSelector((s) => s.productsType.unqTypes) ?? [];
  const hasCartItems = cartItemsCount > 0 || cartItemsLength > 0;
  const hasLikedProducts = likedProductCount > 0 || likedProductsLength > 0;

  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchTypeProducts());
  }, [dispatch]);

  const handleCartClick = () => {
    if (hasCartItems) navigate('/cart');
    else message.warning('Please add a product to the cart.');
  };

  const handleLikedClick = () => {
    if (hasLikedProducts) navigate('/product/liked');
    else message.warning('Please add a product to your favorites.');
  };

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  return (
    <>
      <Header className="header">
        <div className="header__inner">
          <div className="header__left">
            <HeaderNav types={types} className="custom-menu" />
          </div>
          <div className="header__right desktop-only">
            <HeaderActions
              isAuthenticated={isAuthenticated}
              cartItemsCount={cartItemsCount}
              likedProductCount={likedProductCount}
              onCartClick={handleCartClick}
              onLikedClick={handleLikedClick}
              toggleModal={openModal}
            />
          </div>
        </div>
      </Header>
      <nav className="bottom-bar mobile-only" aria-label="Bottom actions">
        <HeaderActions
          isAuthenticated={isAuthenticated}
          cartItemsCount={cartItemsCount}
          likedProductCount={likedProductCount}
          onCartClick={handleCartClick}
          onLikedClick={handleLikedClick}
          toggleModal={openModal}
          className="icon-container--bottom"
        />
      </nav>
      <ModalWindow visible={modalVisible} onCancel={closeModal} />
    </>
  );
};

export default AppHeader;
